var Backbone = require('backbone');


/**
 * Should make an object -- would likely increase performance
 * Not using parse to set height and width; unecessary and can be derived --
 * put fn's on here to show that
 */

module.exports = Backbone.Model.extend({

    defaults: {

        l: null,
        r: null,
        t: null,
        b: null

    },

    // Note: assumed to be 'bbox' order --
    // will come into play for shape select sets
    getBoxCoordinates: function() {

        var attrs = this.attributes;

        return [
            {x: attrs.l, y: attrs.t},
            {x: attrs.r, y: attrs.t},
            {x: attrs.r, y: attrs.b},
            {x: attrs.l, y: attrs.b}
        ];

    },

    getHeight: function() {

        return this.get('b') - this.get('t');

    },

    getWidth: function() {

        return this.get('r') - this.get('l');

    },

    // Now this can likely go on view that would utilize
    // ( For absolute positioning )
    getBoxCssStyle: function() {

        var attrs = this.attributes;

        var style = 'left:' + attrs.l + 'px; ';
        style += 'top:' + attrs.t + 'px; ';

        var width = attrs.r - attrs.l; // maybe better pre conversion ....
        var height = attrs.b - attrs.t;

        style += 'width:' + width + 'px; ';
        style += 'height:' + height + 'px;';

        return style;

    },

    // Create a new box by combing this and another
    combo: function( otherBox ) {

        return new this.constructor({
            l: Math.min( this.get('l'), otherBox.get('l') ),
            r: Math.max( this.get('r'), otherBox.get('r') ),
            t: Math.min( this.get('t'), otherBox.get('t') ),
            b: Math.max( this.get('b'), otherBox.get('b') )
        });

    }


});




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/models/positionalTextModels/textAreaModels/box.js
 ** module id = 350
 ** module chunks = 0
 **/